module.exports = __webpack_public_path__ + "fc458cc6c1848d7fd91de05aba90ac2c.png";